import React from "react"
import { useStats } from "react-instantsearch"

const connectStats = Component => {
  const Stats = props => {
    const data = useStats()

    return <Component {...props} {...data} />
  }

  return Stats
}

const MyStats = ({ nbHits, currentPageNumber }) => {
  return (
    <h2 className="nav-search__stats">
      <span className="nav-search__stats__text">
        Page {currentPageNumber ? currentPageNumber : 1} of {nbHits} results
      </span>
    </h2>
  )
}

const CustomStats = connectStats(MyStats)

export default CustomStats
